import React from 'react';
import Filters from '../Filters';
import PropTypes from 'prop-types';
import Select from 'react-select';
import FilterDate from '../../DateRangeComponent/DateRange';

import './FilterMain.css';
import 'react-select/dist/react-select.css';

export default class FilterMain extends Filters {
  static propTypes = {
    className: PropTypes.string,
    changeFilter: PropTypes.func,
    getOperatorData: PropTypes.func,
    filters: PropTypes.obj,
    operatorData: PropTypes.array,
    initialValues: PropTypes.obj
  };

  componentDidMount(){
    if (this.props.initialValues) {
      this.props.changeFilter(this.props.initialValues);
      this.props.getOperatorData(this.props.initialValues);
    } else {
      this.props.getOperatorData(this.props.filters);
    }
  }

  onItemChange = (field) => (selectedItem) => {
    if(selectedItem) {
      const newFilters = {
        ...this.props.filters,
        [field]: selectedItem.value ? selectedItem.value : selectedItem
      };
      this.props.changeFilter(newFilters);
      this.props.getOperatorData(newFilters);
    } else { // if its a clear operation
      const { [field]: omitThis, ...newFilters } = this.props.filters;
      //Clear operator if country is cleared
      if(field === "countryId") delete newFilters.oc;
      this.props.changeFilter(newFilters);
      this.props.getOperatorData(newFilters);
    }
  }

  onDatesChange = ({startDate, endDate}) => {
    const newFilters = {
      ...this.props.filters,
      startDate: startDate ? startDate.format() : startDate,
      endDate: endDate ? endDate.format() : endDate
    };
    this.props.changeFilter(newFilters)
  }

  render() {

    const countries = this.props.operatorData ? this.props.operatorData.reduce((countriesCurr, operator) => ({
      ...countriesCurr,
      [operator.countryId]: operator.countryName
    }), {}) : {};
    const countriesMaped = Object.keys(countries).map(value => ({ value, label: countries[value] }))

    const operators = this.props.filters && this.props.filters.countryId ? this.props.operatorData.map(operator => ({ value: operator.oc, label: operator.operatorName })) : [];
    const services = this.props.filters && this.props.filters.oc && this.props.operatorData.length ? this.props.operatorData[0].services.map(service => ({ value: service.id, label: service.name })) : [];

    return (
      <div className={`FilterMain ${this.props.className ? this.props.className : ''}`}>
        <Select
          name="form-field-name"
          value={this.props.filters.countryId}
          placeholder="Country"
          className="select"
          onChange={this.onItemChange('countryId')}
          options={countriesMaped}
          isLoading={this.props.loading && !this.props.filters.countryId}
        />
        <Select
          name="form-field-name"
          value={this.props.filters.oc}
          placeholder="Operator"
          className="select"
          onChange={this.onItemChange('oc')}
          options={operators}
          isLoading={this.props.loading && !this.props.filters.oc}
        />
        <Select
          name="form-field-name"
          value={this.props.filters.service}
          placeholder="Services"
          className="select"
          onChange={this.onItemChange('service')}
          options={[
            { value: '*', label: 'All Services' },
            ...services
          ]}
          isLoading={this.props.loading && !this.props.filters.service}
        />
        <FilterDate
          startDate={this.props.filters.startDate}
          endDate={this.props.filters.endDate}
          onChange={this.onDatesChange}
        />
        <Select
          name="form-field-name"
          value={this.props.filters.tz || 'GMT'}
          placeholder="TZ"
          className="select-tz"
          onChange={this.onItemChange('tz')}
          options={[
            { value: 'GMT', label: 'AE' },
            { value: 'Pacific/Tahiti', label: 'TX' },
            { value: 'Asia/Dubai', label: 'SG' },
          ]}
          clearable={false}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Filters/FilterMainComponent/FilterMain.js